import React, { useState, useCallback } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useDropzone } from "react-dropzone";
import { MdClose } from "react-icons/md";
import { GetMedia, Alerts } from "../../../helpers";

const breadcrumbs = [
  { id: 1, label: "Dashboard", link: "/" },
  { id: 2, label: "Categories", link: "/app/Media Library" },
  { id: 3, label: "Create New", link: "/app/media-library/create" },
];

// MultipleFileDropzone Component
const MultipleFileDropzone = ({
  setFieldValue,
  fieldName,
  prevImageWidth = 125,
  prevImageHeight = 125,
}) => {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const newUniqueFiles = acceptedFiles.filter(
        (newFile) =>
          !files.some(
            (existingFile) =>
              existingFile.name === newFile.name &&
              existingFile.size === newFile.size
          )
      );

      const combined = [...files, ...newUniqueFiles];

      if (combined.length > 10) {
        alert("You can only upload up to 10 files.");
        return;
      }

      setFiles(combined);
      setFieldValue(fieldName, combined);
    },
    [files, setFieldValue, fieldName]
  );

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
    setFieldValue(fieldName, newFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
        "image/*": [],
        "video/*": []
      },
    multiple: true,
  });

  return (
    <div className="dropzone-container">
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        <p>Drag & drop files here, or click to select files (Max: 10)</p>
      </div>

      {files.length > 0 && (
        <div className="previewWrapper">
          <div className="row">
            {files.map((file, index) => (
              <div className="col-md-2" key={index}>
                <div
                  className="previewBox"
                  style={{
                    width: prevImageWidth,
                    height: prevImageHeight,
                    position: "relative",
                  }}
                >
                  {file.type.startsWith("image/") ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt={file.name}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <p className="text-truncate">{file.name}</p>
                  )}
                  <button
                    type="button"
                    className="remove-btn"
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      background: "red",
                      border: "none",
                      color: "white",
                      borderRadius: "50%",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => removeFile(index)}
                  >
                    <MdClose />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// CreateMedia Component
const CreateMedia = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData();
    values.media_files.forEach((file) => {
      formData.append("media_file", file);
    });

    try {
      const resp = await GetMedia.createMedia(formData);
      if (resp && resp.status) {
        Alerts.alertMessage(resp.message, "top-right", "success");
        navigate("/app/media-library");
      } else {
        Alerts.alertMessage(resp.message, "top-right", "error");
      }
    } catch (error) {
      Alerts.alertMessage("Something went wrong!", "top-right", "error");
    }

    setSubmitting(false);
  };

  return (
    <>
  
      <div className="innerPageWrapper">
        <div className="container-fluid">
          <div className="page-title">
            <h2>
              <BiCategory /> Create Media
            </h2>
            <Link to="/app/media-library" className="btn btn-success">
              <BiCategory /> Media
            </Link>
          </div>
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={{ media_files: [] }}
                validate={(values) => {
                  const errors = {};
                  if (values.media_files.length === 0) {
                    errors.media_files = "At least one file is required.";
                  } else if (values.media_files.length > 10) {
                    errors.media_files = "You can upload a maximum of 10 files.";
                  }
                  return errors;
                }}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <MultipleFileDropzone
                        setFieldValue={setFieldValue}
                        fieldName="media_files"
                      />
                      {errors.media_files && touched.media_files && (
                        <div className="text-center">
                          <span className="help-error">{errors.media_files}</span>
                        </div>
                      )}
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Uploading..." : "Upload File"}
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMedia;
